import { combineReducers } from 'redux';
import types from './types';

const spaces = (state = [], action) => {
  switch (action.type) {
    case types.GET_SPACES_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const assessment = (state = null, action) => {
  switch (action.type) {
    case types.RUN_ASSESSMENT_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const assessments = (state = [], action) => {
  switch (action.type) {
    case types.GET_ASSESSMENTS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const bhpsFeatures = (state = {}, action) => {
  switch (action.type) {
    case types.GET_BHPS_FEATURES_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const population = (state = [], action) => {
  switch (action.type) {
    case types.GET_POPULATION_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const staffRoi = (state = null, action) => {
  switch (action.type) {
    case types.SET_STAFF_ROI:
      return action.payload;
    default:
      return state;
  }
};

const residentRoi = (state = null, action) => {
  switch (action.type) {
    case types.SET_RESIDENT_ROI:
      return action.payload;
    default:
      return state;
  }
};

const loading = (state = false, action) => {
  switch (action.type) {
    case types.GET_SPACES:
    case types.CREATE_SPACE:
    case types.RUN_ASSESSMENT:
    case types.SAVE_ASSESSMENT:
      return true;
    case types.GET_SPACES_SUCCESS:
    case types.GET_SPACES_FAILURE:
    case types.CREATE_SPACE_SUCCESS:
    case types.CREATE_SPACE_FAILURE:
    case types.RUN_ASSESSMENT_SUCCESS:
    case types.SAVE_ASSESSMENT_SUCCESS:
    case types.SAVE_ASSESSMENT_FAILURE:
      return false;
    default:
      return state;
  }
};

const reducer = combineReducers({
  spaces,
  assessment,
  assessments,
  bhpsFeatures,
  population,
  staffRoi,
  residentRoi,
  loading,
});

export default reducer;
